import React, { useEffect, useState, useMemo } from 'react';

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

function describe(closesAt) {
  const diffMs = new Date(closesAt).getTime() - Date.now();
  if (diffMs <= 0) return { label: 'Closed', closed: true };

  const days = diffMs / DAY_MS;
  if (days > 30) {
    const abs = new Date(closesAt).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric',
    });
    return { label: `Closes ${abs}`, closed: false };
  }

  const wholeDays = Math.floor(days);
  if (wholeDays >= 1) {
    return { label: `Closes in ${wholeDays} day${wholeDays === 1 ? '' : 's'}`, closed: false };
  }

  const hours = Math.max(1, Math.floor(diffMs / HOUR_MS));
  return { label: `Closes in ${hours} hour${hours === 1 ? '' : 's'}`, closed: false };
}

/** "Closes in X days / X hours" — updates at most once a minute, switches to
 * an absolute date beyond 30 days out, and reads "Closed" past closes_at. */
export default function Countdown({ closesAt, className = '' }) {
  const [tickCount, setTickCount] = useState(0);

  useEffect(() => {
    if (!closesAt) return undefined;
    const id = setInterval(() => setTickCount((n) => n + 1), 60000);
    return () => clearInterval(id);
  }, [closesAt]);

  const state = useMemo(() => (closesAt ? describe(closesAt) : null), [closesAt, tickCount]);

  if (!state) return null;

  return (
    <span className={`${className} ve-countdown${state.closed ? ' ve-countdown--closed' : ''}`}>
      {state.label}
    </span>
  );
}
